import { Col, Row, Form as BSForm } from 'react-bootstrap';
import { FieldArray } from 'formik';
import LinkButton from '../../../../ui-elements/signite-link-button/linkButton';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';
import { useEffect, useState } from 'react';
import { CandidateService } from '../../../../../services/candidateService';
export const ProfessionalReferenceForm = ({ handleChange, handleBlur, values, errors, touched, countryCodes }) => {
  return (
    <FieldArray name="professionalReference">
      {({ remove, push }) => (
        <>
          {values.professionalReference &&
            values.professionalReference.length > 0 &&
            values.professionalReference.map((professionalReference, index) => (
              <div key={index}>
                <Row className="mb-2">
                  <BSForm.Group as={Col} controlId="name">
                    <BSForm.Label>Name *</BSForm.Label>
                    <BSForm.Control
                      type="text"
                      name={`professionalReference.${index}.name`}
                      value={_.get(values, `professionalReference.${index}.name`)}
                      placeholder="Name"
                      onChange={handleChange}
                      className={
                        _.get(errors, `professionalReference.${index}.name`)
                          ? 'form-control erroredInput'
                          : 'form-control'
                      }
                    />
                    <span className="errorMessage">{_.get(errors, `professionalReference.${index}.name`)}</span>
                  </BSForm.Group>
                  <BSForm.Group as={Col} controlId="organisation">
                    <BSForm.Label>Organization</BSForm.Label>
                    <BSForm.Control
                      type="text"
                      name={`professionalReference.${index}.organisation`}
                      value={_.get(values, `professionalReference.${index}.organisation`)}
                      placeholder="Organization"
                      onChange={handleChange}
                      className={
                        _.get(errors, `professionalReference.${index}.organisation`)
                          ? 'form-control erroredInput'
                          : 'form-control'
                      }
                    />
                    <span className="errorMessage">{_.get(errors, `professionalReference.${index}.phoneNumber`)}</span>
                  </BSForm.Group>
                  <BSForm.Group as={Col} controlId={`professionalReference.${index}.phoneNumber`}>
                    <Row key={`phone-${index}`}>
                      <Col md={4} lg={4}>
                        <BSForm.Label>Country Code</BSForm.Label>
                        <BSForm.Select
                          name={`professionalReference.${index}.phoneNumber.countryCode`}
                          value={_.get(professionalReference, 'phoneNumber.countryCode')}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(
                            errors,
                            touched,
                            `professionalReference.${index}.phoneNumber.countryCode`
                          )}`}
                        >
                          {countryCodes.map((countryCode, index) => (
                            <option value={countryCode.callingCode} key={index}>
                              {countryCode.displayText}
                            </option>
                          ))}
                        </BSForm.Select>
                      </Col>
                      <Col md={5} lg={5}>
                        <BSForm.Label>Phone Number {`${index == 0 ? '(Primary)' : index + 1}`}</BSForm.Label>
                        <BSForm.Control
                          name={`professionalReference.${index}.phoneNumber.phoneNumber`}
                          value={_.get(professionalReference, 'phoneNumber.phoneNumber')}
                          onChange={handleChange}
                          type="number"
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(
                            errors,
                            touched,
                            `professionalReference.${index}.phoneNumber.countryCode`
                          )}`}
                        ></BSForm.Control>
                        <span className="errorMessage">
                          {getErrorMessage(errors, touched, `professionalReference.${index}.phoneNumber`)}
                        </span>
                      </Col>
                    </Row>
                  </BSForm.Group>
                </Row>
                <Row className="mb-2">
                  <BSForm.Group as={Col} controlId={`professionalReference.${index}.designation`}>
                    <BSForm.Label>Designation</BSForm.Label>
                    <BSForm.Control
                      type="text"
                      name={`professionalReference.${index}.designation`}
                      value={_.get(values, `professionalReference.${index}.designation`)}
                      placeholder="Designation"
                      onChange={handleChange}
                      className={
                        _.get(errors, `professionalReference.${index}.designation`)
                          ? 'form-control erroredInput'
                          : 'form-control'
                      }
                    />
                    <span className="errorMessage">{_.get(errors, `professionalReference.${index}.designation`)}</span>
                  </BSForm.Group>
                  <BSForm.Group as={Col} controlId={`professionalReference.${index}.relation`}>
                    <BSForm.Label>Relation</BSForm.Label>
                    <BSForm.Control
                      type="text"
                      name={`professionalReference.${index}.relation`}
                      value={_.get(values, `professionalReference.${index}.relation`)}
                      placeholder="Relation"
                      onChange={handleChange}
                      className={
                        _.get(errors, `professionalReference.${index}.relation`)
                          ? 'form-control erroredInput'
                          : 'form-control'
                      }
                    />
                    <span className="errorMessage">{_.get(errors, `professionalReference.${index}.relation`)}</span>
                  </BSForm.Group>

                  <BSForm.Group as={Col}>
                    {' '}
                    <BSForm.Group
                      as={Col}
                      controlId="removeCol"
                      className="d-flex justify-content-center align-items-center"
                    >
                      <LinkButton onClick={() => remove(index)} icon={faMinusCircle}></LinkButton>
                    </BSForm.Group>
                  </BSForm.Group>
                </Row>
              </div>
            ))}

          <Row className="mb-3">
            <Col>
              <LinkButton
                label="Add Reference"
                onClick={() =>
                  push({
                    name: '',
                    organisation: '',
                    phoneNumber: '+91',
                    designation: '',
                    relation: '',
                  })
                }
              >
                Add Reference
              </LinkButton>
            </Col>
          </Row>
        </>
      )}
    </FieldArray>
  );
};
